export enum ResponseMode {
  Query = 'query',
  FormPost = 'form_post',
}
